import React from "react";
import MobileProfile from "./profile.mobile/MobileProfile";
import "./mobilemain.css"
import { connect } from "react-redux";

function Mobilemain({ mainView }) {
  return (
    <div className="main-mobile-container translate-y-12 block lg:hidden">
      <MobileProfile />
      {mainView}
    </div>
  );
}
const mapStateToProps = (state) => {
  return state;
};
export default connect(mapStateToProps, null)(Mobilemain);
